(ns dre.modals.question-answering.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.modals.events :as-alias modals]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path
  [:modals :question-answering])

(def options
  [["inaccurate" "Inaccurate"]
   ["out-of-date" "Out of date"]
   ["response-too-short" "Response too short"]
   ["response-too-long" "Response too long"]
   ["did-not-answer-question" "Did not answer question"]
   ["missing-important-info" "Missing important info"]])

;; events
(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} _]
  {:db (-> db
           (assoc :reasons (hash-set)
                  :additional-feedback ""))}))

(rf/reg-event-fx
 ::clear
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [_]]
  {:dispatch [::modals/clear]}))

(rf/reg-event-fx
 ::update-reasons
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [reason]]
  (let [old-reasons (get db :reasons)
        new-reasons (if (contains? old-reasons reason)
                      (disj old-reasons reason)
                      (conj old-reasons reason))]
   {:db (-> db
           (assoc :reasons new-reasons))})))

(rf/reg-event-fx
 ::update-additional-feedback
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [feedback]]
  {:db (-> db
           (assoc :additional-feedback feedback))}))

;; subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db db-path)))


